import { render, staticRenderFns } from "./BillingSection.vue?vue&type=template&id=672a84a3&"
import script from "./BillingSection.vue?vue&type=script&lang=ts&"
export * from "./BillingSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports